<template>
  <div class="scence usercenterLogmanageIndex">
    <div class="content">
      <div class="skt" ref="skt">
        <div class="select flexDiv">
          <span class="desc">起止时间:&nbsp;</span>
          <div class="block flexDiv">
            <el-date-picker
              v-model="query.begTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始时间"
              default-time="08:00:00"
              :picker-options="Global.pickerOptionsStart(query.endTime)"
            >
            </el-date-picker>
            <span>&nbsp;至&nbsp;</span>
            <el-date-picker
              v-model="query.endTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择结束时间"
              default-time="08:00:00"
              :picker-options="Global.pickerOptionsEnd(query.begTime)"
              >
            </el-date-picker>
          </div>
          <span class="desc">请求方式:&nbsp;</span>
          <div class="block flexDiv">
            <el-checkbox-group v-model="checkList"  @change="checkListChange">
              <el-checkbox label="Get"></el-checkbox>
              <el-checkbox label="Post"></el-checkbox>
              <el-checkbox label="Delete"></el-checkbox>
            </el-checkbox-group>
          </div>
          <span class="desc"></span>
          <el-button type="primary" @click="search">查询</el-button>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table style="width: 100%"
              :data="tableData"
              border fit highlight-current-row
              :height="height"
              v-loading="loading"
            >
              <el-table-column type="index" width="60" align="center" label="序号">
                <template slot-scope="scope">
                  <span>{{(query.pageIndex - 1) * query.pageSize + scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间" prop="time_Str" align="center">
              </el-table-column>
              <el-table-column label="接口地址" prop="interfacePath" align="center">
              </el-table-column>
              <el-table-column label="请求方式" prop="method" align="center" width="250">
              </el-table-column>
              <el-table-column label="用户名" prop="userName" align="center" width="250">
              </el-table-column>
              <el-table-column label="IP地址" prop="clientIp" align="center">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div ref="pager" class="pager">
          <el-pagination
            background
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="query.pageIndex"
            :page-size="query.pageSize"
            :page-sizes="[20,50,100,200]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pager from '@/components/Pager'
import usercenterTypes from '@/store/types/usercenter'

export default {
  components: {
    Pager
  },
  data () {
    return {
      loading: false,
      tableData: [],
      checkList: ['Get', 'Post', 'Delete'],
      query: {
        pageIndex: 1,
        pageSize: 100,
        begTime: '',
        endTime: '',
        type: 'Get,Post,Delete'
      },
      total: 0,
      height: 400
    }
  },
  methods: {
    checkListChange () {
      this.query.type = this.checkList.join(',')
    },
    onSizeChange (pageSize) {
      this.query.pageIndex = 1
      this.query.pageSize = pageSize
      this.onLoadData()
    },
    onCurrentChange (pageIndex) {
      this.query.pageIndex = pageIndex
      this.onLoadData()
    },
    search () {
      this.query.pageIndex = 1
      this.onLoadData()
    },
    onLoadData () {
      this.loading = true
      this.$store.dispatch(usercenterTypes.getlog, this.query).then((res) => {
        this.tableData = res.rows
        this.total = res.total
        this.loading = false
      })
    },
    getCurrentTime (hour) {
      let nowdate = new Date()
      nowdate.setTime(nowdate.getTime() - 60 * 60 * 1000 * Number(hour))
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      let mm = nowdate.getMinutes()
      let time =
        year +
        '-' +
        (mon > 9 ? mon : '0' + mon) +
        '-' +
        (dd > 9 ? dd : '0' + dd) +
        ' ' +
        (hh > 9 ? hh : '0' + hh) +
        ':' +
        (mm > 9 ? mm : '0' + mm)
      return time
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', {
          name: this.$route.meta,
          type: this.$route.name
        })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', {
      name: this.$route.meta,
      type: this.$route.name
    })
  },
  mounted () {
    this.query.begTime = this.getCurrentTime(24)
    this.query.endTime = this.getCurrentTime(0)
    this.onLoadData()
    this.$nextTick(() => {
      this.height = this.$refs['skt'].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.usercenterLogmanageIndex {
  width: 100%;
  height: 100%;
  .select{
    .desc{
      padding-left: 20px;
    }
  }
  .flexDiv{
    display: flex;
    align-items: center;
  }
  .pager{
    padding: 10px 20px;
  }
}
</style>
